import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { faCircleExclamation, faCircleXmark, faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-dialog-feedback',
  templateUrl: './dialog-feedback.component.html',
  styleUrls: ['./dialog-feedback.component.scss']
})
export class DialogFeedbackComponent {

  faTimes = faTimes;
  faCircleExclamation = faCircleExclamation;
  faCircleXmark = faCircleXmark;
  faTriangleExclamation = faTriangleExclamation;

  title: string = '';
  subtitle: string = '';
  type: string = '';

  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    if (this.data) {
      this.title = this.data.title;
      this.subtitle = this.data.subtitle;
      this.type = this.data.type;
    }
  }

  closeDialog() {
    this.dialog.closeAll();
  }

}
